import { routeStoreLenses } from 'root/src/client/logic/route/lenses'

const { viewRouteId } = routeStoreLenses

export default (state, { moduleId, routeId }) => {
	const routeIdMod = routeId || viewRouteId(state)
	if (!routeIdMod) return undefined
	return `${routeIdMod}-${moduleId}`
}
